import { Dayjs } from "dayjs";

export type InFlightsType = {
  [InFlightName: string]: { status: InFlightStatuses };
};

export enum InFlightStatuses {
  INITIAL = "INITIAL",
  PENDING = "PENDING",
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
}

export enum InFlightNames {
  requestLoginWithPasswordInflight = "requestLoginWithPasswordInflight",
  requestLogoutInFlight = "requestLogoutInFlight",
  requestReferredUsersInFlight = "requestReferredUsersInFlight",
  requestReferralsInFlight = "requestReferralsInFlight",
  requestUpdateReferralsInFlight = "requestUpdateReferralsInFlight",
  requestPasswordResetInFlight = "requestPasswordResetInFlight",
  requestReferralIncentiveAmountInFlight = "requestReferralIncentiveAmountInFlight",
}
